
// helper/sagas.ts - Utilitários para manipulação de sagas 
import store from 'store'
import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import { RootReducerState, AppDispatch } from 'types/global'
import { select } from 'redux-saga/effects'
import axios, {AxiosResponse, AxiosInstance} from 'axios'
import { REDUX } from 'constants/'
import { createAxiosMocks, getMocksServiceNow } from '__mocks__'
import { applyAuthorizationHeader } from 'helper/getAuthHeader'

const isCypressAuthenticated = () => {
    try {
        return sessionStorage.getItem('test.cypress.authenticated') === 'true'
    } catch {
        return false
    }
}

const isHttpMock = (process.env.REACT_APP_HTTP_MOCK_ON === 'true' || isCypressAuthenticated())
const axiosServiceNowApiInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_PROXY_URL
})
/**
 * Reescrita dos hooks de manipulação useDispath e useSelector para o redux-sagas
 */
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootReducerState> = useSelector
/**
 * Função usada para auxiliar a seleção de informações direto do state com typescript, usada como selector para o obter um reducer especifico
 * @param selector 
 */
export function* appSelect<TSelected>( selector: (state: RootReducerState) => TSelected, ): Generator<any, TSelected, TSelected> { return yield select(selector) }

const buildRequestConfig = () => {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
    applyAuthorizationHeader(headers)
    return { headers }
}

/**
 * Utilitários do client axios de sagas (headers de auth montados por request)
 */
export const axiosConfig = {
    createMocks:(instance:AxiosInstance) => isHttpMock && createAxiosMocks(getMocksServiceNow(), instance),
    showLoading:() => !isHttpMock && store.dispatch({ type: REDUX.reducers.SHOW_LOADING, payload: null}),
    hideLoading:() => !isHttpMock && store.dispatch({ type: REDUX.reducers.HIDE_LOADING, payload: null}),
    getRequestConfig: buildRequestConfig
}
/**
 * Abaixo objeto com as operações Axios
 * foi criada instancia do Axios separada porque redux-sagas não suporta interceptors
 */
export const axiosSagas = {
    post: async<T,A> (payload: T, url:string) => {
        axiosConfig.createMocks(axiosServiceNowApiInstance)
        axiosConfig.showLoading()
        const { data }:AxiosResponse<A> = await axiosServiceNowApiInstance.post<A>(`${url}`, payload, axiosConfig.getRequestConfig())
        axiosConfig.hideLoading()
        return data
      },
    get: async<T,A> (url:string)=> {
        axiosConfig.createMocks(axiosServiceNowApiInstance)
        axiosConfig.showLoading()
        const { data }:AxiosResponse<A> = await axiosServiceNowApiInstance.get<A>(`${url}`, axiosConfig.getRequestConfig())
        axiosConfig.hideLoading()
        return data
    },
    put: async<T,A> (payload: A, url:string) => {
        axiosConfig.createMocks(axiosServiceNowApiInstance)
        axiosConfig.showLoading()
        const { data }:AxiosResponse<A> = await axiosServiceNowApiInstance.put<A>(`${url}`, payload, axiosConfig.getRequestConfig())
        axiosConfig.hideLoading()
        return data
    }

}
